import { render, staticRenderFns } from "./EditRoomComponent.vue?vue&type=template&id=fc47bc74"
import script from "./EditRoomComponent.vue?vue&type=script&lang=ts"
export * from "./EditRoomComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports